import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';
import { firstDayofYear, lastDayofYear, recentOneYearStr, recentOneYearEndStr } from '../../utils/calcDatetime';

const [
  LIST_BASE_CHANCES,
  LIST_BASE_CHANCES_SUCCESS,
  LIST_BASE_CHANCES_FAILURE,
] = createRequestActionTypes('chance/LIST_BASE_CHANCES');

export const listBaseChances = createAction(
  LIST_BASE_CHANCES,
  (searchData) => searchData,
);
const listBaseChancesSaga = createRequestSaga(
  LIST_BASE_CHANCES,
  chanceApi.getBaseChances,
);

const SET_BASE_FITERS = 'chance/SET_BASE_FITERS';
export const setBaseFilters = createAction(
  SET_BASE_FITERS,
  (filters) => filters,
);

const RESET_BASE_FILTERS = 'chance/RESET_BASE_FILTERS';
export const resetBaseFilters = createAction(RESET_BASE_FILTERS);

export function* chanceBasesSaga() {
  yield takeLatest(LIST_BASE_CHANCES, listBaseChancesSaga);
}

const initialState = {
  totals: null,
  chances: null,
  error: null,
  defaultFilters: {
    useYn: 'Y',
    searchGrade: '',
    searchPrjTyp: '',

    searchPrjImpt: ['High', 'Medium'],
    searchKeyword: 'cstNm',
    searchWords: '',
    // 매출 예정일 기본 조회범위는 앞뒤 1년(작년 오늘 ~ 내년 오늘)이다.
    // 비워두면 전체 기간이 조회돼 목록이 과도하게 길어지고,
    // 금년(1/1~12/31)으로 잡으면 연초에 비어 보이고 작년 건이 통째로 빠진다.
    // 끝을 오늘로 막으면 앞으로 잡힌 건이 안 보인다 — 매출 예정일은 대개 미래 날짜다.
    searchStrtDt: recentOneYearStr,
    searchEndDt: recentOneYearEndStr,
    searchDpt: '',
    searchUsr: '',
  },
};



const chanceBases = handleActions(
  {
    [LIST_BASE_CHANCES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data?.totals,
      chances: data.list.map((chance) => ({
        id: chance.prjUuid,
        prjSeq: chance.prjSeq,
        prjUuid: chance.prjUuid,
        prjNo: chance.prjNo,
        cstNm: chance.cstNm,
        cstStatus: chance.cstStatus,
        cstGrade: chance.cstGrade,
        prjTyp: chance.prjTyp,
        // partnerInc: chance.partnerInc,
        // chargeNm: chance.chargeNm,
        // chargeEml: chance.chargeEml,
        // chargeTel: chance.chargeTel,
        chanceTyp: chance.chanceTyp,
        prjImpt: chance.prjImpt,
        bugetYn: chance.bugetYn,
        // partnerTyp: chance.partnerTyp,
        incTyp: chance.incTyp,
        // solutionTyp: chance.solutionTyp,
        productYn: chance.productYn,
        vendorCmp: chance.vendorCmp,
        vendorCmpNm: chance.vendorCmpNm,
        // vendorEmp: chance.vendorEmp,
        // vendorEmpNm: chance.vendorEmpNm,
        expBenefitRate: chance.expBenefitRate,
        expSales: chance.expSales,
        expBuy: chance.expBuy,
        expDay: chance.expDay,
        // pmUsr: chance.pmUsr,
        // pmNm: chance.pmNm,
        // plUsr: chance.plUsr,
        // plNm: chance.plNm,
        // techUsr: chance.techUsr,
        // techNm: chance.techNm,
        costYn: chance.costYn,
        mtnFreeTor: chance.mtnFreeTor,
        mtnPayTor: chance.mtnPayTor,
        mtnFreeSt: chance.mtnFreeSt,
        mtnFreeEd: chance.mtnFreeEd,
        mtnPaySt: chance.mtnPaySt,
        mtnPayEd: chance.mtnPayEd,
        totalPurchase: chance?.totalPurchase,
        totalSales: chance?.totalSales,
        totalProfit: chance?.totalProfit,
        totalMargin: chance?.totalMargin,
        useYn: chance.useYn,
        crtDptNm: chance.crtDptNm,
        crtNm: chance.crtNm,
        crtGradeNm: chance.crtGradeNm,
        crtDt: chance.crtDt,
        cngNm: chance.cngNm,
        cngDt: chance.cngDt,
      })),
      error: null,
    }),
    [LIST_BASE_CHANCES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [RESET_BASE_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_BASE_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default chanceBases;
